export default __webpack_public_path__ + "e6787d573a0c8553c336be9f048e89df.png";